import { useEffect, useState } from "react";
import {
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  Autocomplete,
  TextField,
  CircularProgress,
} from "@mui/material";
import { apiRequest } from "../components/Config";
import { Col } from "react-bootstrap";

export default function LocationSelect({
  values,
  setFieldValue,
  errors,
  touched,
}) {
  const [voivodeshipList, setVoivodeshipList] = useState([]);
  const [cities, setCities] = useState([]);
  const [loadingCities, setLoadingCities] = useState(false);

  useEffect(() => {
    apiRequest("voivodeship").then(setVoivodeshipList);
  }, []);

  const fetchCities = async (id) => {
    if (!id) return;
    setLoadingCities(true);
    const res = await apiRequest(`cities/${id}`);
    setCities(res || []);
    setLoadingCities(false);
  };

  return (
    <>
      <Col xs={12} md={6}>
        <FormControl
          fullWidth
          margin="normal"
          error={touched.voivodeship && Boolean(errors.voivodeship)}
        >
          <InputLabel>Województwo</InputLabel>
          <Select
            value={values.voivodeship}
            onChange={(e) => {
              const vId = e.target.value;
              setFieldValue("voivodeship", vId);
              setFieldValue("city", null);
              fetchCities(vId);
            }}
          >
            {voivodeshipList.map((v) => (
              <MenuItem key={v.id} value={v.id}>
                {v.nazwa}
              </MenuItem>
            ))}
          </Select>
        </FormControl>
      </Col>
      <Col xs={12} md={6}>
        <Autocomplete
          options={cities}
          getOptionLabel={(o) => o.nazwa || ""}
          value={values.city}
          disabled={!values.voivodeship}
          loading={loadingCities}
          onChange={(_, v) => setFieldValue("city", v)}
          renderInput={(params) => (
            <TextField
              {...params}
              label="Miasto"
              margin="normal"
              error={touched.city && Boolean(errors.city)}
              helperText={touched.city && errors.city}
              InputProps={{
                ...params.InputProps,
                endAdornment: (
                  <>
                    {loadingCities && <CircularProgress size={20} />}
                    {params.InputProps.endAdornment}
                  </>
                ),
              }}
            />
          )}
        />
      </Col>
    </>
  );
}
